// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"where-i-posted-view_shadow__1NlpB","heading":"where-i-posted-view_heading__JhHJO"};